var _rect, _rect2, _rect3, _rect4, _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 120",
    fill: "none",
    role: "img",
    "aria-label": "Office chair",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    rx: 10,
    fill: "#EEF2F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 28,
    width: 56,
    height: 44,
    rx: 10,
    fill: "#002454"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 36,
    width: 40,
    height: 28,
    rx: 6,
    fill: "#1A3D6B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 72,
    width: 12,
    height: 22,
    rx: 4,
    fill: "#9e00ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 94 H116",
    stroke: "#002454",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 94,
    rx: 36,
    ry: 6,
    fill: "#002454",
    opacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductChair);
export default __webpack_public_path__ + "static/media/product-chair.a7cd4f4bf862c3c881822e028dc19a79.svg";
export { ForwardRef as ReactComponent };